<template>
  <div class="container-fluid">
    <div class="card shadow">
      <div class="card-header py-3">
        <p
          class="m-0"
          style="font-size: 15px; color: var(--bs-body-color); font-weight: bold"
        >
          {{ $t("productcatlog") }}
        </p>
      </div>
      <div class="card-body">
        <div
          id="dataTable"
          class="table-responsive table mt-2"
          role="grid"
          aria-describedby="dataTable_info"
          style="overflow-y: hidden"
        >
          <div>
            <el-row>
              <el-col :offset="8" :span="5">
                <el-input v-model="searchText"> </el-input>
              </el-col>
              <el-col :span="1">
                <el-button @click="OnSearchClick">{{ $t("search") }}</el-button>
              </el-col>
            </el-row>
            <li
              style="padding: 15px; margin-top: 15px; text-align: left"
              class="list-group-item"
              v-if="!isInSecondLevel"
            >
              <img class="icon" src="../assets/icon.png" />
              <span style="display: inl ine-block; width: 500px">
                <a
                  style="font-size: 15px"
                  href="javascript:;"
                  @click="OpenPage({ id: -1 })"
                >
                  {{ $t("allproduct") }}
                </a>
              </span>
            </li>
            <li
              style="padding: 15px; text-align: left"
              class="list-group-item"
              v-if="isInSecondLevel"
            >
              <svg
                width="80px"
                height="80px"
                viewBox="0 0 100 100"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <image
                    width="200"
                    height="200"
                    xlink:href="data:image/png;base64,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"
                    id="img_1"
                  />
                </defs>
                <use
                  xlink:href="#img_1"
                  fill="#FFFFFF"
                  stroke="none"
                  transform="scale(0.5 0.5)"
                />
              </svg>
              <span style="display: inl ine-block; width: 500px">
                <a
                  style="font-size: 15px"
                  href="javascript:;"
                  @click="
                    DataList = alldata;
                    isInSecondLevel = false;
                  "
                >
                  {{ $t("back") }}
                </a>
              </span>
            </li>
            <li
              v-for="element in DataList"
              :key="element.name"
              style="padding: 15px; text-align: left"
              class="list-group-item"
            >
              <img
                onerror="javascript:this.src='data:image/svg+xml;base64,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';"
                class="icon"
                :src="element.icon"
              />
              <span style="display: inline-block; width: 500px">
                <a style="font-size: 15px" href="javascript:;" @click="OpenPage(element)">
                  {{ $tt(element.name) }}
                </a>
              </span>
            </li>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router/index";
import "../common/httphelper";
import swal from "sweetalert2";
import getRole from "../common/role";
import {
  AddProductCatlog,
  DeleteProductCatlog,
  GetProductCatlog,
  SortProductCatlog,
  UpdateProductCatlog,
} from "../common/httphelper";
import Swal from "sweetalert2";
import draggable from "vuedraggable";
import { generate } from "@vue/compiler-core";

export default {
  data() {
    return {
      searchText: "",
      DataList: [],
      role: {},
      isInSecondLevel: false,
      alldata: [],
    };
  },
  methods: {
    OnSearchClick() {
      if (!this.searchText) {
        Swal.fire("请输入搜索内容");
        return;
      }

      router.push({
        name: "ProductSearch",
        query: { catlog: -2, value: this.searchText },
      });
    },

    OpenPage(item) {
      if (item.Children) {
        this.DataList = item.Children;
        this.isInSecondLevel = true;
        return;
      }

      router.push({ name: "ProductSearch", query: { catlog: item.id } });
    },

    RefreshList() {
      GetProductCatlog().then((res) => {
        if (res.data.code == 20000) {
          this.DataList = this.GenerateList(res.data.data);
        }
      });
    },

    GenerateList(data) {
      let motor = data.filter((item) => item.name.includes("电机"));
      let motorSet = data.filter((item) => item.name.includes("马达座"));
      let meter = data.filter((item) => item.name.includes("码表"));
      let cable = data.filter((item) => item.name.includes("线缆"));

      let motorCatlog = {
        id: 24,
        name: "电机☆Motor",
        isCatlog: true,
        index: 0,
        icon: "https://api.motinova.com:924/Icon/24_19.png",
        Children: motor,
      };

      let motorSetCatlog = {
        id: 24,
        name: "马达座☆MotorSet",
        isCatlog: true,
        index: 0,
        icon: "https://api.motinova.com:924/Icon/37_3.png",
        Children: motorSet,
      };

      let cableCatlog = {
        id: 24,
        name: "线缆☆Cable",
        isCatlog: true,
        index: 0,
        icon: "https://api.motinova.com:924/Icon/32_91.png",
        Children: cable,
      };

      let meterCatlog = {
        id: 24,
        name: "码表☆Meter",
        isCatlog: true,
        index: 0,
        icon: "https://api.motinova.com:924/Icon/35_86.png",
        Children: meter,
      };

      this.alldata = [motorCatlog, motorSetCatlog, cableCatlog, meterCatlog].concat(
        data.filter(
          (item) =>
            !(
              item.name.includes("电机") ||
              item.name.includes("马达座") ||
              item.name.includes("码表") ||
              item.name.includes("线缆")
            )
        )
      );

      return this.alldata;
    },

    onEnd() {
      for (let n = 0; n < this.DataList.length; n++) {
        this.DataList[n].index = n;
      }
      let res = this.DataList.map((v) => {
        return {
          id: v.id,
          index: v.index,
        };
      });
      SortProductCatlog(res);
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  mounted() {
    this.RefreshList();
    this.role = getRole();
  },
};
</script>

<style scoped>
a {
  color: #4e73df;
  text-decoration: none;
  cursor: pointer;
}

.handle {
  float: left;
  margin-right: 15px;
  font-size: 18px;
  cursor: Move;
  line-height: 24px;
}

.icon {
  height: 80px;
  width: 80px;
}
</style>
